import { useEffect } from 'react';

import { debounce } from 'lodash-es';
import { useDispatch } from 'react-redux';
import { Route, Routes } from 'react-router';

import { SearchTypeahead } from 'src/common/SearchTypeahead';

import { setPricingSearchTerm } from './pricingModel.slice';
export function PricingRouteActions() {
  return (
    <Routes>
      <Route index element={<RouteActions />} />
      <Route path=":selectedPricingModelId" element={<RouteActions />} />
      <Route
        path=":selectedPricingModelId/pricing-type/:selectedPricingTypeId"
        element={<RouteActions />}
      />
    </Routes>
  );
}

export function RouteActions() {
  const dispatch = useDispatch();
  const debounceSearch = debounce(handleSearch, 300);

  function handleSearch(term: string) {
    dispatch(setPricingSearchTerm(term));
  }

  useEffect(() => {
    return () => {
      dispatch(setPricingSearchTerm(''));
    };
  }, [dispatch]);

  return (
    <div className="flex items-center gap-4 pb-2">
      <SearchTypeahead
        dataTestId="pricing-search"
        onChange={debounceSearch}
        placeholder="Search pricing models"
      />
    </div>
  );
}
